export default "__VITE_ASSET__9xIH8xKm__"